export const MOCK_ACADEMIC_OFFICERS = {
  "data": [
    {
      "type": "AcademicOfficer",
      "id": "10000",
      "attributes": {
        "isMockData": true,
        "first_name": "Alice",
        "middle_name": "M",
        "last_name": "Johnson",
        "emp_id": "EMP9001",
        "uni": "UNI9001",
        "title": "Professor",
        "position_department": "Biology",
        "reporting_unit": "College of Science",
        "admin_department": "Admin Bio Dept",
        "campus": "Morningside",
        "dob": "1975-06-14",
        "first_appointment_date": "2005-08-01",
        "status": "Active",
        "visiting": false,
        "visiting_start_date": null,
        "visiting_end_date": null,
        "cc_start_date": null,
        "cc_end_date": null,
        "non_professorial_rank": false,
        "nonprofessorial_rank_start_date": null,
        "nonprofessorial_rank_end_date": null,
        "candidate_clearance": false,
        "phased_retirement": false,
        "email": "alice.johnson@univ.edu",
        "tenure_type": "001",
        "profile_image_url": null,
        "sabbatical_eligibility": null,
        "review_schedule": null,
        "relationships": {
          "tenured_faculty_service_record": {
            "data": [
              {
                "type": "tenured_faculty_service_record",
                "id": "9",
                "attributes": {
                  "earned_credits_to_date": "13.00",
                  "applied_credits_to_date": "12.50",
                  "remaining_credits_to_date": "5.00",
                  "nontenured_credits": "3.00",
                  "other_service_credits": "2.50",
                  "academic_year_last_postponement": null,
                  "credit_deficit": "0.00",
                  "last_sabbatical_due": null,
                  "last_sabbatical_taken": null,
                  "next_sabbatical_due": null,
                  "tenure_start_date": "2026-09-06"
                }
              },
              {
                "type": "tenured_faculty_service_record",
                "id": "1",
                "attributes": {
                  "earned_credits_to_date": "11.00",
                  "applied_credits_to_date": "6.00",
                  "remaining_credits_to_date": "6.00",
                  "nontenured_credits": null,
                  "other_service_credits": "1.00",
                  "academic_year_last_postponement": null,
                  "credit_deficit": null,
                  "last_sabbatical_due": "2016-01-01",
                  "last_sabbatical_taken": "2019-01-15",
                  "next_sabbatical_due": "2027-01-01",
                  "tenure_start_date": "2027-09-08"
                }
              }
            ]
          },
          "nontenured_faculty_service_record": {
            "data": []
          },
          "subsequent_review": {
            "data": []
          },
          "leave_history": {
            "data": []
          },
          "positions": {
            "data": [
              {
                "type": "academic_officer_position",
                "id": "1",
                "attributes": {
                  "position_title": "Professor of Computer Science",
                  "full_part_time": "Full-Time",
                  "position_department": "Computer Science",
                  "academic_rank": "Professor",
                  "position_entry_dt": "2005-08-01"
                }
              },
              {
                "type": "academic_officer_position",
                "id": "6",
                "attributes": {
                  "position_title": "Department Chair",
                  "full_part_time": "Full-Time",
                  "position_department": "Computer Science",
                  "academic_rank": "Professor",
                  "position_entry_dt": "2015-09-01"
                }
              }
            ]
          }
        }
      }
    },
    {
      "type": "AcademicOfficer",
      "id": "10001",
      "attributes": {
        "isMockData": true,
        "first_name": "Bob",
        "middle_name": "R",
        "last_name": "Smith",
        "emp_id": "EMP9002",
        "uni": "UNI9002",
        "title": "Associate Professor",
        "position_department": "Physics",
        "reporting_unit": "College of Science",
        "admin_department": "Admin Physics Dept",
        "campus": "Morningside",
        "dob": "1980-03-22",
        "first_appointment_date": "2010-09-01",
        "status": "Active",
        "visiting": true,
        "visiting_start_date": "2024-01-01",
        "visiting_end_date": "2024-12-31",
        "cc_start_date": "2023-06-01",
        "cc_end_date": "2025-05-31",
        "non_professorial_rank": false,
        "nonprofessorial_rank_start_date": null,
        "nonprofessorial_rank_end_date": null,
        "candidate_clearance": true,
        "phased_retirement": false,
        "email": "bob.smith@univ.edu",
        "tenure_type": "003",
        "profile_image_url": null,
        "sabbatical_eligibility": null,
        "review_schedule": null,
        "relationships": {
          "tenured_faculty_service_record": {
            "data": []
          },
          "nontenured_faculty_service_record": {
            "data": [
              {
                "type": "nontenured_faculty_service_record",
                "id": "1",
                "attributes": {
                  "sixth_year_review": "2023-05-15",
                  "tenure_clock_start_date": "2018-09-01",
                  "probationary_period_end_date": "2024-08-31"
                }
              }
            ]
          },
          "subsequent_review": {
            "data": []
          },
          "leave_history": {
            "data": []
          },
          "positions": {
            "data": [
              {
                "type": "academic_officer_position",
                "id": "2",
                "attributes": {
                  "position_title": "Associate Professor of Physics",
                  "full_part_time": "Full-Time",
                  "position_department": "Physics",
                  "academic_rank": "Associate Professor",
                  "position_entry_dt": "2010-09-01"
                }
              }
            ]
          }
        }
      }
    },
    {
      "type": "AcademicOfficer",
      "id": "10002",
      "attributes": {
        "isMockData": true,
        "first_name": "Carol",
        "middle_name": null,
        "last_name": "Davis",
        "emp_id": "EMP9003",
        "uni": "UNI9003",
        "title": "Assistant Professor",
        "position_department": "Chemistry",
        "reporting_unit": "College of Science",
        "admin_department": "Admin Chemistry Dept",
        "campus": "Medical Center",
        "dob": "1985-11-08",
        "first_appointment_date": "2020-08-01",
        "status": "Active",
        "visiting": false,
        "visiting_start_date": null,
        "visiting_end_date": null,
        "cc_start_date": null,
        "cc_end_date": null,
        "non_professorial_rank": true,
        "nonprofessorial_rank_start_date": "2020-08-01",
        "nonprofessorial_rank_end_date": null,
        "candidate_clearance": false,
        "phased_retirement": false,
        "email": "carol.davis@univ.edu",
        "tenure_type": "004",
        "profile_image_url": null,
        "sabbatical_eligibility": null,
        "review_schedule": null,
        "relationships": {
          "tenured_faculty_service_record": {
            "data": []
          },
          "nontenured_faculty_service_record": {
            "data": [
              {
                "type": "nontenured_faculty_service_record",
                "id": "2",
                "attributes": {
                  "sixth_year_review": null,
                  "tenure_clock_start_date": "2020-08-01",
                  "probationary_period_end_date": "2026-07-31"
                }
              }
            ]
          },
          "subsequent_review": {
            "data": []
          },
          "leave_history": {
            "data": []
          },
          "positions": {
            "data": [
              {
                "type": "academic_officer_position",
                "id": "3",
                "attributes": {
                  "position_title": "Assistant Professor of Chemistry",
                  "full_part_time": "Part-Time",
                  "position_department": "Chemistry",
                  "academic_rank": "Assistant Professor",
                  "position_entry_dt": "2020-08-01"
                }
              }
            ]
          }
        }
      }
    }
  ]
};